export const CAL_EVENT_CONTACT_KINDS = [
    'hiredStaff',
    'storeStaff',
    'newConnection',
    'vendor',
    'other',
];
//# sourceMappingURL=cal-event-contact-kind.js.map